export default "__VITE_ASSET__DcD4YR36__"